import { h } from 'preact'
import { SortableHandle } from 'react-sortable-hoc'
import Union from '../category/assets/Union'

const DragHandle = SortableHandle(() => {
  return (
    <span class='drag-handle--union'>
      <Union />
    </span>
  )
})

export default DragHandle
